/**
 * DialogHelpers - Utility functions for showing alert and confirm dialogs
 */

// Helper function to show an alert dialog
export function showAlert(title: string, message: string): Promise<void> {
    return new Promise((resolve) => {
        const dialogRoot = document.getElementById('alert-dialog-root');
        if (!dialogRoot) {
            resolve();
            return;
        }

        const React = (window as any).React;
        const ReactDOM = (window as any).ReactDOM;
        const AlertDialog = (window as any).AlertDialog;
        if (!React || !ReactDOM || !AlertDialog) {
            resolve();
            return;
        }

        const handleClose = () => {
            if (ReactDOM.createRoot) {
                const root = (window as any).alertDialogRoot;
                if (root) root.render(null);
            } else {
                ReactDOM.render(null, dialogRoot);
            }
            resolve();
        };

        if (ReactDOM.createRoot) {
            let root = (window as any).alertDialogRoot;
            if (!root) {
                root = ReactDOM.createRoot(dialogRoot);
                (window as any).alertDialogRoot = root;
            }
            root.render(React.createElement(AlertDialog, {
                title: title,
                message: message,
                onClose: handleClose
            }));
        } else {
            ReactDOM.render(
                React.createElement(AlertDialog, {
                    title: title,
                    message: message,
                    onClose: handleClose
                }),
                dialogRoot
            );
        }
    });
}

// Helper function to show a confirm dialog
export function showConfirm(title: string, message: string): Promise<boolean> {
    return new Promise((resolve) => {
        const dialogRoot = document.getElementById('confirm-dialog-root');
        if (!dialogRoot) {
            resolve(false);
            return;
        }

        const React = (window as any).React;
        const ReactDOM = (window as any).ReactDOM;
        const ConfirmDialog = (window as any).ConfirmDialog;
        if (!React || !ReactDOM || !ConfirmDialog) {
            resolve(false);
            return;
        }

        const handleConfirm = () => {
            if (ReactDOM.createRoot) {
                const root = (window as any).confirmDialogRoot;
                if (root) root.render(null);
            } else {
                ReactDOM.render(null, dialogRoot);
            }
            resolve(true);
        };

        const handleCancel = () => {
            if (ReactDOM.createRoot) {
                const root = (window as any).confirmDialogRoot;
                if (root) root.render(null);
            } else {
                ReactDOM.render(null, dialogRoot);
            }
            resolve(false);
        };

        if (ReactDOM.createRoot) {
            let root = (window as any).confirmDialogRoot;
            if (!root) {
                root = ReactDOM.createRoot(dialogRoot);
                (window as any).confirmDialogRoot = root;
            }
            root.render(React.createElement(ConfirmDialog, {
                title: title,
                message: message,
                onConfirm: handleConfirm,
                onCancel: handleCancel
            }));
        } else {
            ReactDOM.render(
                React.createElement(ConfirmDialog, {
                    title: title,
                    message: message,
                    onConfirm: handleConfirm,
                    onCancel: handleCancel
                }),
                dialogRoot
            );
        }
    });
}

// Make available globally
(window as any).showAlert = showAlert;
(window as any).showConfirm = showConfirm;
